import api from "./client";

export const listTransformers = async () => {
  const { data } = await api.get("/transformers/");
  return data;
};

export const listTransformersBySite = async (siteId) => {
  const { data } = await api.get(`/transformers/site/${siteId}`);
  return data;
};

export const createTransformer = async (payload) => {
  const { data } = await api.post("/transformers/", payload);
  return data;
};

export const deleteTransformer = async (id) => {
  const { data } = await api.delete(`/transformers/${id}/`);
  return data;
};

export const canDeleteTransformer = async (id) => {
  const { data } = await api.get(`/transformers/${id}/can_delete`);
  return data;
};

export const updateTransformer = async (id, payload) => {
  const { data } = await api.put(`/transformers/${id}`, payload);
  return data;
};
